/**
 * main.js
 *
 * @author
 * @version 1.0.0
 * @copyright 2018 SEDA.digital GmbH & Co. KG
 *
 * @typedef {import('vue-router').Route} VueRouterRoute
 */

import './foundation';
import './general'; // Is this used?
import Vue from 'vue';
import App from './App.vue';
import Store from './store';
import Router from './router';
import I18n from './i18n';
import Vuelidate from 'vuelidate';
import Api from './api';
import Vuebar from 'vuebar';
import GeoCoder from './geocoder';
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(VueTippy);
Vue.use(Vuelidate);
Vue.use(Vuebar);
Vue.component("tippy", TippyComponent);

Vue.prototype.$api = Api;
Vue.prototype.$geocoder = GeoCoder;

Vue.config.debug = true;
Vue.config.devtools = true;

/**
 * Modernizr
 *
 * to customize the modernizr tools and functions edit the `.modernizrrc.js` file
 */
import './modernizr.js';

// Helpers
import helpers from './helpers';

Vue.prototype.$helpers = helpers;

Api.init();

/**
 * Determine whether the a possibly logged-in user didn’t accept the required user-tracking yet.
 *
 * @param {VueRouterRoute} targetRoute
 *
 * @returns {Boolean}
 */
/* function userHasNotAcceptedTracking(targetRoute) {
    const user = Store.getters.getUser;

    return user.loggedin &&
           !user.hasAcceptedUserTracking &&
           targetRoute.name !== 'logout' &&
           targetRoute.name !== 'account-accept-activity-flow' // this check avoids infinite redirects to the account update page
} */

/**
 * @TODO Fix for when refreshing page
 */
Router.beforeEach((to, from, next) => {
    if (from.name) {
        helpers.history = from;
    }
/*
    if (userHasNotAcceptedTracking(to)) {
        return next({ name: 'account-accept-activity-flow' });
    } */

    if (helpers.publicAccess.indexOf(to.name) === -1) {
        let permission = to.meta.permission;

        if (Store.getters.isLoading) {
            const watcher = Store.watch(() => {
                return Store.getters.isLoading;
            }, () => {
                watcher();
                if (!Api.userHasAccess(permission, to)) {
                    next({
                        name: 'login'
                    });
                } else {
                    next();
                }
            });
        } else {
            if (!Api.userHasAccess(permission, to)) {
                next({
                    name: 'login'
                });
            } else {
                next();
            }
        }
    } else {
        if (to.name === 'login') {
            if (Store.getters.isLoading) {
                const watcher = Store.watch(() => {
                    return Store.getters.isLoading;
                }, () => {
                    watcher();
                    if (Store.getters.getUser.loggedin) {
                        next({
                            name: 'home'
                        });
                    } else {
                        next();
                    }
                });
            } else {
                if (Store.getters.getUser.loggedin) {
                    next({
                        name: 'home'
                    });
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    }
});


window.app = new Vue({
    el: '#application',
    i18n: I18n,
    store: Store,
    router: Router,
    render: h => h(App)
});
